export default __webpack_public_path__ + "static/media/poof.1ebbcdd5.gif";